import { Directive, inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FormData } from '../../model/form-data.model';
import { SpreadRecursive } from '../../services/spread-recursive';

@Directive()
export abstract class AbstractFormBuilderComponent implements OnInit {
    protected fb = inject(UntypedFormBuilder);

    form: UntypedFormGroup;

    ngOnInit(): void {
        this.form = this.buildForm(this.createForm());
        this.afterFormBuilt();
    }

    protected afterFormBuilt(): void { /* nothing to do */ }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected buildForm(form: object|Array<any>): UntypedFormGroup {
        const formGroup = {};

        for (const input in form) {
            if (!Object.prototype.hasOwnProperty.call(form,input)) {
                continue;
            }
            if (form[input] instanceof UntypedFormControl) {
                formGroup[input] = form[input];
            } else if (null !== form[input] && 'object' === typeof form[input] && !Array.isArray(form[input])) {
                formGroup[input] = this.buildForm(form[input]);
            } else if (null !== form[input] && 'object' === typeof form[input] && Array.isArray(form[input])) {
                let array: Array<AbstractControl> = [];
                for (const subInput of form[input]) {
                    if (null !== subInput && 'object' === typeof subInput) {
                        array = [...array, this.buildForm(subInput)];
                    } else {
                        array = [...array, this.fb.control(subInput)];
                    }
                }
                formGroup[input] = this.fb.array(array);
            } else {
                formGroup[input] = form[input];
            }
        }

        return this.fb.group(formGroup);
    }

    protected getFormData(): FormData {
        return SpreadRecursive.clone(this.form.value);
    }

    protected abstract createForm(): object;
}
